<template>
  <div class="H5toApp">
    <div class="appIcon">
      <img src="../assets/images/appIcon.png" alt="" />
    </div>
    <div class="btn firstBtn">
      <button @click="openApp">打开鹿路通</button>
    </div>
    <div class="btn lastBtn">
      <button @click="downloadAPP">下载鹿路通</button>
    </div>
    <van-popup v-model="show" class="tanchu" :close-on-click-overlay="false">
      <div class="inTanchu">
        <div class="chaIcon" @click="show = false">
          <img src="../assets/images/chaIcon.png" alt="" />
        </div>
        <div class="head">提示</div>
        <div class="tishiIcon">
          <img src="../assets/images/downloadIcon.png" alt="" />
        </div>
        <div class="word firstWord">您还未安装这个应用，请去应用市场下</div>
        <div class="word lastWord">下载“鹿路通”APP。</div>
        <div class="confirmBtn" @click="show = false">
          <button>好的，知道了</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Popup } from "vant";

Vue.use(Popup);
export default {
  mounted() {
    this.openApp();
  },
  data() {
    return {
      show: false,
      IosUrl:
        "https://apps.apple.com/cn/app/%E6%98%86%E5%B1%B1%E5%B8%82%E6%B0%91%E5%8D%A1-%E6%98%86%E5%B1%B1%E5%B8%82%E6%B0%91%E7%9A%84%E6%9C%AC%E5%9C%B0%E7%94%9F%E6%B4%BB%E6%9C%8D%E5%8A%A1%E5%B9%B3%E5%8F%B0/id1151763857",
    };
  },
  methods: {
    //点击打开鹿路通
    openApp() {
      let that = this;
      let ua = navigator.userAgent;
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isAndroid) {
        window.location.href =
          "citizencard://psbc.open?appId=I21060922274262600001";
      }
      if (isiOS) {
        // window.location.href = "https://app.systoon.com/kssmk?appid=1151763857";
        // window.open("applinks:app.systoon.com/kssmk", "_self");
        // setTimeout(function () {
        //   window.location.href = that.IosUrl;
        // }, 25);
      }
    },
    //点击下载鹿路通
    downloadAPP() {
      let ua = navigator.userAgent;
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isAndroid) {
        this.show = true;
      }
      if (isiOS) {
        window.open(this.IosUrl, "_self");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.H5toApp {
  background: linear-gradient(180deg, #ffffff 0%, #f1fefb 24.1%, #fbfbfb 100%);
  padding-top: 13.625rem;
}
.appIcon {
  text-align: center;
  img {
    width: 27.375rem;
  }
}
.btn {
  text-align: center;
  padding: 0 4.75rem;
  button {
    width: 100%;
    height: 6rem;
    line-height: 6rem;
    border: none;
    background: linear-gradient(90deg, #19a0a0 0%, #0f7876 100%);
    border-radius: 3rem;
    color: #ffffff;
    font-size: 2rem;
  }
}
.firstBtn {
  margin-top: 10rem;
}
.lastBtn {
  margin-top: 3.875rem;
}
.tanchu {
  width: 91.5%;
  background: #ffffff;
  border-radius: 0.75rem;
  .inTanchu {
    padding: 2.375rem 0 3.875rem 0;
    position: relative;
    .chaIcon {
      position: absolute;
      top: 2.625rem;
      right: 2.625rem;
      img {
        width: 1.625rem;
      }
    }
    .head {
      text-align: center;
      color: #19212a;
      font-size: 2.5rem;
    }
    .tishiIcon {
      margin-top: 1.25rem;
      text-align: center;
      img {
        width: 12.75rem;
      }
    }
    .word {
      text-align: center;
      color: #3d3d3d;
      font-size: 2rem;
    }
    .firstWord {
      margin-top: 3.125rem;
    }
    .lastWord {
      margin-top: 0.625rem;
    }
    .confirmBtn {
      margin-top: 2.625rem;
      padding: 0 9rem;
      text-align: center;
      button {
        width: 100%;
        height: 5rem;
        line-height: 5rem;
        background: linear-gradient(90deg, #19a0a0 0%, #0f7876 100%);
        border-radius: 2.5rem;
        border: none;
        color: #ffffff;
        font-size: 2rem;
        font-weight: bold;
      }
    }
  }
}
</style>